module.exports = __webpack_public_path__ + "img/กุ้งมังกร.189bc317.png";